import { render, staticRenderFns } from "./PraiseColumn.vue?vue&type=template&id=36581f05&scoped=true&"
import script from "./PraiseColumn.vue?vue&type=script&lang=js&"
export * from "./PraiseColumn.vue?vue&type=script&lang=js&"
import style0 from "./PraiseColumn.vue?vue&type=style&index=0&id=36581f05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36581f05",
  null
  
)

export default component.exports